'use client';

import './mobile-navigation-bar.scss';

interface Props {
  onBack: () => void;
  onNext?: () => void;
  backLabel?: string;
  nextLabel?: string;
}

export default function MobileNavigationBar({
  onBack,
  onNext,
  backLabel = 'BACK',
  nextLabel = 'NEXT',
}: Props) {
  return (
    <div className='mobile-navigation-bar'>
      <div className='mobile-navigation-bar-gradient' />
      <div className='mobile-navigation-bar-buttons'>
        <button
          type='button'
          className='mobile-navigation-bar-button'
          onClick={onBack}
        >
          {backLabel}
        </button>
        {onNext && (
          <button
            type='button'
            className='mobile-navigation-bar-button'
            onClick={onNext}
          >
            {nextLabel}
          </button>
        )}
      </div>
    </div>
  );
}
